<!-- <app-button-close-promotion></app-button-close-promotion> -->
<div mat-dialog-content style="text-align: -webkit-center;padding: 0px;">
    <img src="{{file}}" width="250px" height="250px">
</div>
<!-- <app-button-order [data]="message" [showButton]="isButton"></app-button-order> -->